import { availIncentivizedCoupon, fetchIncentivizedCouponCode } from './Api';
import {
  attachListener,
  deleteCacheForKeys,
  getCacheForKey,
  removeListener,
  REQUEST_STATUS,
  setCacheForKey
} from './CacheManager';
import { getCompanyId } from './Company';

const createKeyForDefaultCoupon = () => 'DEFAULT_VISITOR_COUPON';

export const getCachedDefaultCoupon = () =>
  getCacheForKey(createKeyForDefaultCoupon()) || undefined;

export const attachCouponChangeListener = ({ listener }) => {
  attachListener({ key: createKeyForDefaultCoupon(), listener });
};

export const removeCouponChangeListener = ({ listener }) => {
  removeListener({ key: createKeyForDefaultCoupon(), listener });
};

export const getCachedDefaultCouponData = () => {
  const couponData = getCachedDefaultCoupon();
  if (couponData) {
    return couponData.data;
  }
};

export const setDefaultCouponData = ({ status, data }) => {
  const modifiedCoupon = { ...getCachedDefaultCoupon() };
  if (status) {
    modifiedCoupon.status = status;
  }

  if (data) {
    modifiedCoupon.data = {
      ...(modifiedCoupon.data || {}),
      ...data
    };
  }

  setCacheForKey(
    {
      key: createKeyForDefaultCoupon(),
      value: modifiedCoupon
    },
    { notify: true }
  );
};

export const deleteCachedCouponData = () => {
  deleteCacheForKeys([createKeyForDefaultCoupon()], { notify: true });
};

export const fetchIncentiveCoupon = () => {
  setDefaultCouponData({
    status: REQUEST_STATUS.LOADING
  });

  return fetchIncentivizedCouponCode({ companyId: getCompanyId() })
    .then(({ couponCode }) => {
      if (couponCode === null) {
        deleteCachedCouponData();
        return;
      }

      setDefaultCouponData({
        status: REQUEST_STATUS.COMPLETE,
        data: {
          code: couponCode
        }
      });
    })
    .catch(() => {
      setDefaultCouponData({
        status: REQUEST_STATUS.ERROR
      });
      return Promise.reject();
    });
};

export const availIncentiveCouponCode = (visitorData) => {
  setDefaultCouponData({
    status: REQUEST_STATUS.LOADING
  });

  return availIncentivizedCoupon({ companyId: getCompanyId(), updates: visitorData })
    .then(({ couponCode }) => {
      setDefaultCouponData({
        status: REQUEST_STATUS.COMPLETE,
        data: {
          code: couponCode
        }
      });
      return couponCode;
    })
    .catch(() => {
      setDefaultCouponData({
        status: REQUEST_STATUS.ERROR
      });
      return Promise.reject();
    });
};
